module.exports = __webpack_public_path__ + "static/media/g.73a54a1c.png";